import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  HStack,
  Text,
  Switch,
  FormControl,
  FormLabel,
  Divider,
  useToast,
  Box,
  Heading,
  SimpleGrid,
  Badge,
  Icon,
  Tooltip
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  closeAdminPanel, 
} from '../../Redux/Mode/action';
import { FaTools, FaUsers, FaInbox, FaServer, FaCrown, FaEnvelope } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import BurrowSpinner from '../UI/BurrowSpinner';

const AdminPanel = () => {  const dispatch = useDispatch();
  const toast = useToast();
  const isOpen = useSelector(state => state.Mode?.isAdminPanelOpen) || false;
  const isAdmin = useSelector(state => 
    state.auth?.isAdmin || 
    state.auth?.role === 'admin' || 
    state.auth?.accountType === 'admin' ||
    state.auth?.user?.role === 'admin' || 
    state.auth?.user?.accountType === 'admin'
  );
  const adminLevel = useSelector(state => state.auth?.adminLevel || state.auth?.user?.adminLevel);
  const isOwner = adminLevel === 'owner';
  const navigate = useNavigate();
  
  const [isSpinnerModalOpen, setSpinnerModalOpen] = useState(false);
  
  const handleClose = () => {
    dispatch(closeAdminPanel());
  };
  
const handleOpenUserManagement = () => {
    // Close the admin panel first
    dispatch(closeAdminPanel());
    
    // Need to delay navigation slightly to ensure panel closes first
    setTimeout(() => {
      // Then navigate to the user management page
      navigate('/admin/users');
      
      console.log('Navigating to user management, admin status:', isAdmin);
    }, 100);
  };
  
  const handleOpenInbox = () => {
    // Close the admin panel first
    dispatch(closeAdminPanel());
    
    // Need to delay navigation slightly to ensure panel closes first
    setTimeout(() => {
      // Then navigate to the admin inbox page
      navigate('/admin/inbox');
      
      console.log('Navigating to admin inbox');
    }, 100);
  };
    const handleOpenTicketInbox = () => {
    // Close the admin panel first
    dispatch(closeAdminPanel());
    
    // Need to delay navigation slightly to ensure panel closes first
    setTimeout(() => {
      // Then navigate to the admin inbox page
      navigate('/admin/inbox');
      
      console.log('Navigating to admin inbox, admin status:', isAdmin);
    }, 100);
  };

  const handleOpenAdminMessages = () => {
    dispatch(closeAdminPanel());
    setTimeout(() => {
      navigate('/admin/messages');
    }, 100);
  };
  
  const handleOpenStabilityMonitoring = () => {
    // Close the admin panel first
    dispatch(closeAdminPanel());
    
    // Need to delay navigation slightly to ensure panel closes first
    setTimeout(() => {
      // Then navigate to the stability monitoring page
      navigate('/admin/stability');
      
      console.log('Navigating to stability monitoring, admin status:', isAdmin);
    }, 100);
  };

  const handleOpenAdminTeam = () => {
    dispatch(closeAdminPanel());
    setTimeout(() => {
      navigate('/admin/manage-admins');
    }, 100);
  };
  
  return (
    <>
      <Modal 
        isOpen={isOpen} 
        onClose={handleClose}
        size="lg"
      >
        <ModalOverlay backdropFilter="blur(2px)" />
        <ModalContent bg="gray.800" color="white">
          <ModalHeader>
            <HStack>
              <Icon as={FaTools} mr={2} />
              <Text>Admin Panel</Text>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />
          
          <ModalBody>
            <VStack spacing={6} align="stretch">
              
              <Box bg="purple.900" p={4} borderRadius="md">
                <Heading size="sm" mb={3}>User Management</Heading>
                <Button 
                  leftIcon={<FaUsers />} 
                  colorScheme="purple" 
                  size="sm"
                  onClick={handleOpenUserManagement}
                  width="full"
                >
                  Manage User Accounts
                </Button>
              </Box>                <Box bg="blue.900" p={4} borderRadius="md">
                <Heading size="sm" mb={3}>Support Management</Heading>
                <VStack spacing={2}>
                  <Button 
                    leftIcon={<FaInbox />} 
                    colorScheme="blue" 
                    size="sm"
                    onClick={handleOpenTicketInbox}
                    width="full"
                  >
                    Support Ticket Inbox
                  </Button>
                  <Button 
                    leftIcon={<FaEnvelope />} 
                    colorScheme="purple" 
                    size="sm"
                    onClick={handleOpenAdminMessages}
                    width="full"
                  >
                    Admin Messages
                  </Button>
                </VStack>
              </Box>
              
                <Box bg="green.900" p={4} borderRadius="md">
                <Heading size="sm" mb={3}>System Monitoring</Heading>
                <Button 
                  leftIcon={<FaServer />} 
                  colorScheme="green"
                  width="100%"
                  onClick={handleOpenStabilityMonitoring}
                >
                  Stability Monitoring
                </Button>
                <Text fontSize="sm" mt={2} color="gray.400">
                  Monitor system health, performance, and manage database & security settings.
                </Text>
              </Box>

              {isOwner && (
                <Box bg="yellow.900" p={4} borderRadius="md" borderColor="yellow.700" borderWidth="1px">
                  <Heading size="sm" mb={3}>
                    <HStack><Icon as={FaCrown} color="yellow.500" /><Text>Owner Controls</Text></HStack>
                  </Heading>
                  <Button 
                    leftIcon={<FaCrown />} 
                    colorScheme="yellow"
                    width="100%"
                    onClick={handleOpenAdminTeam}
                  >
                    Manage Admin Team
                  </Button>
                  <Text fontSize="sm" mt={2} color="gray.400">
                    Promote, demote, and manage admin/moderator access levels.
                  </Text>
                </Box>
              )}
              
              <Box bg="teal.900" p={4} borderRadius="md">
                <Heading size="sm" mb={3}>Active Settings</Heading>
                  
                <Button mt={4} colorScheme="teal" onClick={() => setSpinnerModalOpen(true)}>
                  View Spinner
                </Button>
              </Box>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={handleClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Spinner Modal */}
      <Modal isOpen={isSpinnerModalOpen} onClose={() => setSpinnerModalOpen(false)} size="xs" isCentered>
        <ModalOverlay />
        <ModalContent bg="gray.800" color="white">
          <ModalHeader>View Spinner</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={6}>
              <BurrowSpinner size="120px" />
              <Text mt={4}>This is the custom Burrow Spinner.</Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AdminPanel;
